import { IoArrowBack, IoArrowForward } from "react-icons/io5";

interface StepNavigationProps {
  onBack?: () => void;
  onNext?: () => void;
  showBack?: boolean;
  showNext?: boolean;
  nextDisabled?: boolean;
  nextLabel?: string;
  backLabel?: string;
}

export const StepNavigation = ({
  onBack,
  onNext,
  showBack = true,
  showNext = true,
  nextDisabled = false,
  nextLabel = "Próximo",
  backLabel = "Voltar",
}: StepNavigationProps) => {
  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white shadow-lg border-t border-gray-200 z-50">
      <div className="flex items-center justify-between p-4 gap-3">
        {showBack ? (
          <button
            onClick={onBack}
            className="flex items-center gap-2 px-4 py-3 bg-gray-100 text-gray-700 rounded-lg font-medium hover:bg-gray-200 transition-colors duration-200"
          >
            <IoArrowBack className="text-lg" />
            <span className="text-sm">{backLabel}</span>
          </button>
        ) : (
          <div />
        )}

        {showNext && (
          <button
            onClick={onNext}
            disabled={nextDisabled}
            className={`flex items-center gap-2 px-8 py-3 rounded-lg font-semibold flex-1 justify-center transition-all duration-200 ${
              nextDisabled
                ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                : "bg-gradient-to-r from-[hsl(var(--primary))] to-[hsl(var(--secondary))] text-white hover:from-[hsl(var(--primary))]/90 hover:to-[hsl(var(--secondary))]/90 shadow-md"
            }`}
          >
            <span>{nextLabel}</span>
            <IoArrowForward className="text-lg" />
          </button>
        )}
      </div>
    </div>
  );
};
